import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ResultsHubPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const disciplines = [
    {
      key: 'speed',
      label: t('resultsHub.speed.label'),
      description: t('resultsHub.speed.description'),
      path: '/speed-schedule',
      color: 'from-yellow-500 to-orange-500',
      icon: '⚡',
    },
    {
      key: 'boulder',
      label: t('resultsHub.boulder.label'),
      description: t('resultsHub.boulder.description'),
      path: '/boulder-results',
      color: 'from-green-500 to-teal-600',
      icon: '🪨',
    },
    {
      key: 'lead',
      label: t('resultsHub.lead.label'),
      description: t('resultsHub.lead.description'),
      path: '/lead-results',
      color: 'from-blue-500 to-indigo-600',
      icon: '🧗',
    },
  ];

  return (
    <div className="min-h-screen bg-dark text-white">
      <div className="max-w-3xl mx-auto px-4 py-16">
        <h1 className="text-4xl font-bold text-center mb-2 tracking-tight">
          {t('resultsHub.title')}
        </h1>
        <p className="text-center text-gray-400 mb-12 text-lg">
          {t('resultsHub.subtitle')}
        </p>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {disciplines.map(d => (
            <button
              key={d.key}
              onClick={() => navigate(d.path)}
              className={`
                bg-gradient-to-br ${d.color}
                rounded-2xl p-6 text-left shadow-lg
                hover:scale-105 active:scale-95
                transition-transform duration-150 focus:outline-none focus:ring-2 focus:ring-white
              `}
            >
              <div className="text-4xl mb-3">{d.icon}</div>
              <h2 className="text-xl font-bold mb-1">{d.label}</h2>
              <p className="text-sm text-white/80 leading-snug">{d.description}</p>
            </button>
          ))}
          <button
            onClick={() => navigate('/athletes')}
            className="
              bg-gradient-to-br from-purple-500 to-slate-600
              rounded-2xl p-6 text-left shadow-lg
              hover:scale-105 active:scale-95
              transition-transform duration-150 focus:outline-none focus:ring-2 focus:ring-white
            "
          >
            <div className="text-4xl mb-3">👤</div>
            <h2 className="text-xl font-bold mb-1">{t('resultsHub.athletes.label')}</h2>
            <p className="text-sm text-white/80 leading-snug">{t('resultsHub.athletes.description')}</p>
          </button>
          <button
            onClick={() => navigate('/schedule')}
            className="
              bg-gradient-to-br from-slate-500 to-slate-700
              rounded-2xl p-6 text-left shadow-lg
              hover:scale-105 active:scale-95
              transition-transform duration-150 focus:outline-none focus:ring-2 focus:ring-white
            "
          >
            <div className="text-4xl mb-3">📅</div>
            <h2 className="text-xl font-bold mb-1">{t('resultsHub.schedule.label')}</h2>
            <p className="text-sm text-white/80 leading-snug">{t('resultsHub.schedule.description')}</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResultsHubPage;
